export default "__VITE_ASSET__DwsXFysP__"